import { render } from "./b-text-short.vue?vue&type=template&id=0696a2aa&scoped=true"
import script from "./b-text-short.vue?vue&type=script&lang=js"
export * from "./b-text-short.vue?vue&type=script&lang=js"

import "./b-text-short.vue?vue&type=style&index=0&id=0696a2aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0696a2aa"]])

export default __exports__